
/*
    Container for showing a list of Quarterly report records,
    split with media queries for different screen sizes,
    with the ability to filter by date and export to PDF

    Uses AutoSizer + FixedSizeList to ensure that only those
    records which are currently on screen are rendered
*/

import React, { useContext } from "react";
import Media from "react-media";

import MainContext from "../MainContext";
import DataContext from "../DataContext";

import VerticalLayout from "../Components/VerticalLayout";
import SubNav from "../Components/SubNav";

import ReportQuarterlyFilter from "../Filters/ReportQuarterlyFilter";
import ReportQuarterlyData from "../DataDisplay/ReportQuarterlyData";

import ReportExport from "../Components/Excel/ReportExport";

import { getQuarterlyReport, getQuarterlyReportPDF } from "../Requests/ReportRequests";

// total height of 45px on laptop, 97px on tablet

import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

//
// wrapper component to make sure that we can immediately reload if set by the DataContext
//
const ReportQuarterlyPageContainer = (props) => {
    const context = useContext(DataContext);

    return (
        <ReportQuarterlyPage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default ReportQuarterlyPageContainer;


class ReportQuarterlyPage extends React.Component {

    static contextType = MainContext;

    state = {
        filterValues: null,
        data: [],
        message: ""
    }

    //
    //
    applyFilter = (values, callback) => {
        this.context.toggleFilter();
        this.setState({filterValues: values}, () => {
            this.getData(callback);
        });
    }

    //
    //
    getData = (callback) => {
        const request = () => getQuarterlyReport(this.state.filterValues);
            const then = ({data}) => {

                const message = (data.length > 0) ? "" : "No Records Found for this Filter";

                this.setState({data, message}, () => {
                    if(callback && typeof callback === "function"){
                        callback();
                    }
                });
            };

            this.context.runProcessing(request, then, "getQuarterlyReport");
    }

    //
    //
    runPDF = () => {
        const request = () => getQuarterlyReportPDF(this.state.filterValues);
        const then = (res => {
            ;
        });
        this.context.runProcessing(request, then, "getStarterSheetPDF");
    }

    //
    // necessary method for getting the AutoSizer + FixedSizeList to work
    //
    NextRow = ({ index, style }) => (
        <div style={style}>
            <ReportQuarterlyData key={index} data={this.state.data[index]} />
        </div>
    )

    //
    //
    componentDidUpdate() {
        if(this.props.dataReload){
            console.log("GET DATA!!!");
            this.props.setReload(false, () => {                
                this.getData();
            });
        }
    }

    render() {

        return (
            <>
            <Media query="(max-width: 811px)">
                <VerticalLayout firstHeight={(this.state.data.length === 0 || this.context.filterOpen) ? 0 : 8}>
                    {
                        // if the filter isn't open, then show the export option
                        !this.context.filterOpen && this.state.data.length > 0
                        ?<div>
                            <SubNav>
                                <ReportExport filename={`Quarterly Report ${new Date()}`} data={[{name: `Report`, records: this.state.data}]} filter={this.state.filterValues} />
                                <div className="option  " onClick={this.runPDF}>PDF</div>
                            </SubNav>
                        </div>
                        : null
                    }
                    <div className="content-nooverflow" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                        <>
                        {
                            // the filter
                            this.context.hasFilter
                            && this.context.filterOpen
                                ? <ReportQuarterlyFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                : null
                        }
                        {
                            this.state.data.length > 0
                            ? <AutoSizer>
                            {
                                ({height, width}) => (
                                    <FixedSizeList
                                    className="fixed-list"
                                    height={height}
                                    width={width}
                                    itemCount={this.state.data.length}
                                    itemSize={97}
                                    >
                                    {this.NextRow}
                                    </FixedSizeList>
                                )
                            }
                            </AutoSizer>
                            : null
                        }
                        {
                            this.state.message
                            ? <div className="message">
                                {this.state.message}
                            </div>
                            : null
                        }
                        </>
                    </div>
                </VerticalLayout>
            </Media>
            <Media query="(min-width: 812px)">
                <VerticalLayout firstHeight={(this.state.data.length === 0 || this.context.filterOpen) ? 0 : 14}>
                    {
                    !this.context.filterOpen && this.state.data.length > 0
                    ? <div>
                        <SubNav>
                            <ReportExport filename={`Quarterly Report ${new Date()}`} data={[{name: `Report`, records: this.state.data}]} filter={this.state.filterValues} />
                            <div className="option  " onClick={this.runPDF}>PDF</div>
                        </SubNav>
                        <div className="data" style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 2fr 1fr 2fr 2fr 2fr 2fr 2fr",
                            justifyItems: "center",
                            alignItems: "center",
                            gridGap: "4px",
                            margin: "8px 24px 0 8px",
                            fontWeight: "bold",
                            background: "var(--purple)"
                        }}>
                            <div>Route</div>
                            <div>Total</div>
                            <div>Sched<br />Late</div>
                            <div>Sched<br />OT%</div>
                            <div>Run<br />Late</div>
                            <div>Run<br />OT%</div>
                            <div>PASS</div>
                            <div>Boarding</div>
                            <div>Arriving</div>
                            <div>Getting<br />Off</div>
                            <div>Left<br />Behind</div>
                            <div>Departing</div>
                        </div>
                    </div>
                    : null
                    }
                    <div className="content-nooverflow" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                        <>
                        {
                            this.context.hasFilter
                            && this.context.filterOpen
                                ? <ReportQuarterlyFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                : null
                        }
                        <AutoSizer>
                        {
                            ({height, width}) => (
                                <FixedSizeList
                                className="fixed-list"
                                height={height}
                                width={width}
                                itemCount={this.state.data.length}
                                itemSize={45}
                                >
                                {this.NextRow}
                                </FixedSizeList>
                            )
                        }
                        </AutoSizer>
                        {
                            this.state.message
                            ? <div className="message">
                                {this.state.message}
                            </div>
                            : null
                        }
                        </>
                    </div>
                </VerticalLayout>
            </Media>
            </>
        );
    }
}